module.exports = __webpack_public_path__ + "static/media/CreateReturn5.a235ee2d.png";